
export default function AboutSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              Design + Engenharia = Confiança
            </h2>
            <div className="space-y-4 text-base text-[#3F3F3F] leading-relaxed">
              <p>
                Na P&P, acreditamos que a verdadeira excelência nasce da integração total entre arquitetura e engenharia. Cada projeto é desenvolvido com rigor técnico e sensibilidade estética, garantindo não apenas beleza, mas também eficiência e segurança.
              </p>
              <p>
                Nossa abordagem vai além do convencional: combinamos criatividade arquitetônica com precisão de engenharia, criando espaços que impressionam pela funcionalidade e encantam pela estética refinada.
              </p>
              <p>
                Do conceito inicial à aprovação final, acompanhamos cada etapa com dedicação e expertise, assegurando que sua visão se transforme em realidade dentro dos mais altos padrões de qualidade.
              </p>
            </div>
            
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="text-center p-4 bg-[#F2F2F2] rounded-lg">
                <div className="w-10 h-10 bg-[#5C1A24] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-compass-3-line text-white text-lg"></i>
                </div>
                <h4 className="font-semibold text-[#3F3F3F] mb-1 text-sm">Planejamento Estratégico</h4>
                <p className="text-xs text-gray-600">Cada detalhe pensado com precisão</p>
              </div>
              <div className="text-center p-4 bg-[#F2F2F2] rounded-lg">
                <div className="w-10 h-10 bg-[#5C1A24] rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-white text-lg"></i>
                </div>
                <h4 className="font-semibold text-[#3F3F3F] mb-1 text-sm">Garantia de Qualidade</h4>
                <p className="text-xs text-gray-600">Excelência em cada entrega</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img
                src="https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/423e3cfb06fbae8270906bf39e74bf63.jpeg"
                alt="Equipe P&P trabalhando em projetos"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5C1A24]/20 to-transparent"></div>
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-gray-100">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-[#5C1A24] rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-white text-lg"></i>
                </div>
                <div>
                  <div className="text-xl font-bold text-[#5C1A24]">6+</div>
                  <div className="text-xs text-gray-600">Anos de Experiência</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
